<div [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    size="small"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="true"
    [zIndex]="1003"
  >
  </ngx-spinner>
  <div class="d-flex justify-content-between" *ngIf="isExpand">
    <div></div>

    <nb-card class="cursor-pointer classroom-details">
      <nb-card-body>
        <div class="d-flex justify-content-between">
          <div class="classroom-name-content text-left">
            <h5 class="classroom-name quicksand-bold-label">
              {{ classroom?.name }}
            </h5>

            <div class="classroom-subject quicksand-bold-label">
              {{ classroom?.subject | uppercase }}
            </div>
          </div>

          <div class="d-flex" style="margin-right: -5px">
            <div class="classroom-code text-center">
              {{ classroom?.code }}
            </div>
          </div>
        </div>
      </nb-card-body>
    </nb-card>

    <div class="text-right mb-3 btn-close-content">
      <button class="btn-close" (click)="closeExpandView()" [disabled]="isStreamingContinue">
        <nb-icon icon="collapse" class="icon-close-expand-view"></nb-icon>
      </button>
    </div>
  </div>

  <div class="{{ isExpand ? 'extra-help-main-content pt-4' : '' }}">
    <div *ngIf="isExpand" class="text-center container">
      <h6 class="quicksand-bold-label">Extra Help</h6>
      <figure class="image-container">
        <img src="/assets/images/student-extra-help.svg" alt="student-extra-help" />

        <figcaption class="quicksand-normal-label fig-caption">Search for a solution or get help!</figcaption>
      </figure>
    </div>

    <div class="row d-flex justify-content-center {{ isExpand ? 'mt-4' : '' }}">
      <div class="help-section-content {{ currentUser ? 'm-auto' : '' }}">
        <div
          (click)="
            !currentUser
              ? changeExtraHelpMode(
                  studentExtraHelpMode.Generate_Solution_From_AI,
                  extraHelpMode !== studentExtraHelpMode.Generate_Solution_From_AI ? true : false
                )
              : null
          "
          class="extra-help-column-content  generate-solution-content pt-3 text-center {{ isExpand ? 'expand-section' : '' }} {{
            extraHelpMode === studentExtraHelpMode.Generate_Solution_From_AI ? 'border' : ''
          }}"
        >
          <img src="/assets/icons/help-by-ai.svg" alt="generate-solution-content" height="40" width="40" class="mt-2" />

          <br />
          <label
            class="quicksand-bold-label mt-2 cursor-pointer"
            [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-mode-white-color' : 'dark-mode-black-color'"
            >Explain The Solution</label
          >
        </div>
      </div>

      <div class="help-section-content mr-md-3 ml-md-3 ml-lg-5 mr-lg-5" *ngIf="!currentUser">
        <div
          (click)="changeExtraHelpMode(studentExtraHelpMode.Ask_Student, extraHelpMode !== studentExtraHelpMode.Ask_Student ? true : false)"
          class="extra-help-column-content  ask-student-content pt-3 text-center {{ isExpand ? 'expand-section' : '' }} {{
            extraHelpMode === studentExtraHelpMode.Ask_Student ? 'border' : ''
          }}"
        >
          <img src="/assets/icons/ask-student.svg" alt="ask-student-content" height="50" width="50" />
          <br />

          <label
            class="quicksand-bold-label mt-1 cursor-pointer"
            [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-mode-white-color' : 'dark-mode-black-color'"
            >Ask a Student</label
          >
        </div>
      </div>

      <div class="help-section-content" *ngIf="!currentUser">
        <div
          (click)="changeExtraHelpMode(studentExtraHelpMode.Ask_Teacher, extraHelpMode !== studentExtraHelpMode.Ask_Teacher ? true : false)"
          class="extra-help-column-content ask-teacher-content ask-teacher-card pt-3 text-center {{ isExpand ? 'expand-section' : '' }} {{
            extraHelpMode === studentExtraHelpMode.Ask_Teacher ? 'border' : ''
          }}"
        >
          <img src="/assets/icons/ask-teacher.svg" alt="ask-teacher-content" height="50" width="50" />
          <br />

          <label
            class="quicksand-bold-label mt-1 cursor-pointer"
            [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-mode-white-color' : 'dark-mode-black-color'"
            >Ask a Teacher</label
          >
        </div>
      </div>
    </div>

    <div class="{{ isExpand ? 'main-help-content' : '' }}">
      <hr class="hr-content mt-4" *ngIf="isExpand" />
      <div class="row pb-4 pt-3">
        <div
          [ngSwitch]="extraHelpMode"
          [ngClass]="{
            'col-8': isHistoryOpen && !storageService.detectMob(),
            'col-12': !isHistoryOpen || storageService.detectMob()
          }"
        >
          <!-- *ngIf="studentQuestions?.length > 0" -->
          <div *ngSwitchCase="studentExtraHelpMode.Ask_Teacher">
            <ng-container [ngTemplateOutlet]="askTeacherContent"></ng-container>
          </div>
          <div *ngSwitchCase="studentExtraHelpMode.Ask_Student">
            <ng-container [ngTemplateOutlet]="askStudentContent"></ng-container>
          </div>
          <div *ngSwitchCase="studentExtraHelpMode.Generate_Solution_From_AI">
            <ng-container [ngTemplateOutlet]="generateSolutionContent"></ng-container>
          </div>
        </div>
        <div
          *ngIf="isHistoryOpen"
          [ngClass]="{
            'col-4': !storageService.detectMob(),
            'col-12': storageService.detectMob()
          }"
          class="previous-history-content"
        >
          <h6 class="quicksand-bold-label mt-3">
            Previously
            {{
              extraHelpMode === studentExtraHelpMode.Ask_Student
                ? 'Student'
                : extraHelpMode === studentExtraHelpMode.Ask_Teacher
                ? 'Teacher'
                : extraHelpMode === studentExtraHelpMode.Generate_Solution_From_AI
                ? 'AI'
                : 'Default'
            }}
            Asked Questions
          </h6>
          <div>
            <div class="questions-content mt-3">
              <div class="form-group has-search mr-3">
                <img src="/assets/icons/search.svg" alt="search-icon" class="mt-1 form-control-feedback" height="17" width="17" />
                <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchText" />
              </div>

              <div class="questions-loop">
                <ng-container *ngIf="studentPreviouslyAskedQuestions | search : searchText as filteredQuestions">
                  <!-- Display filtered questions -->
                  <div class="mt-3 main-questions-view-content quicksand-bold-label d-flex cursor-pointer" *ngFor="let question of filteredQuestions">
                    <div (click)="showQuestionRecord($event, question)">
                      <nb-icon icon="arrow-ios-back-outline" class="see-question-icon"></nb-icon>
                    </div>
                    <div class="quicksand-bold-label" (click)="showQuestionRecord($event, question)">
                      {{ question?.question }}
                    </div>
                    <div (click)="openDeleteModal(question?.id)" class="delete ml-auto">
                      <img src="/assets/icons/delete.svg" alt="delete-icon" class="cursor-pointer" height="20" width="20" />
                    </div>
                  </div>

                  <!-- Show message if no results -->
                  <div class="text-center ml-auto" *ngIf="filteredQuestions.length === 0">
                    <img src="/assets/images/respond-edu.svg" height="100" width="100" alt="no-data-found" />
                    <h6 class="quicksand-bold-label">No Questions Found!</h6>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template #expandContent>
      <div [ngClass]="analyticsService?.currentTheme">
        <div class="btn-close-content float-right">
          <button class="btn-close" (click)="closeExpandView()">
            <nb-icon icon="collapse" class="icon-close-expand-view"></nb-icon>
          </button>
        </div>
      </div>
    </ng-template>

    <ng-template #askTeacherContent class="mt-2">
      <div [ngClass]="analyticsService?.currentTheme">
        <div class="mt-4" [ngClass]="!storageService.detectMob() ? (isHistoryOpen ? 'student-help-content-padd' : 'student-help-content') : ''">
          <h6 class="quicksand-bold-label ask-teacher-text">Ask a teacher</h6>
          <!-- <button
            color="primary"
            class="restore-button ml-2 {{
              isExpand ? 'btn-gen-mr' : 'btn-gen-mr-exp'
            }}"
            (click)="checkHistory()"
            title="See Previous Questions"
            *ngIf="extraHelpMode !== ''"
            [ngClass]="isHistoryOpen ? 'restore-button-pos' : 'float-right'"
          >
            <img
              src="/assets/icons/restore-clock.svg"
              height="16"
              width="16"
              class="bulk-compose-icon-mob"
              alt="no-img"
            />
          </button> -->
          <label class="extra-help-description quicksand-normal-label"> You can message a teacher to request help. </label>

          <ng-container [ngTemplateOutlet]="selectNoteQuestionContent"></ng-container>
        </div>
      </div>
    </ng-template>

    <ng-template #askStudentContent>
      <div [ngClass]="analyticsService?.currentTheme">
        <div class="mt-4" [ngClass]="!storageService.detectMob() ? (isHistoryOpen ? 'student-help-content-padd' : 'student-help-content') : ''">
          <h6
            class="quicksand-bold-label m-0"
            [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-mode-white-color' : 'dark-mode-black-color'"
          >
            Ask a student
          </h6>

          <!-- <button
            color="primary"
            class="restore-button ml-2  {{
              isExpand ? 'btn-gen-mr' : 'btn-gen-mr-exp'
            }}"
            (click)="checkHistory()"
            title="See Previous Questions"
            *ngIf="extraHelpMode !== ''"
            [ngClass]="isHistoryOpen ? 'restore-button-pos' : 'float-right'"
          >
            <img
              src="/assets/icons/restore-clock.svg"
              height="16"
              width="16"
              class="bulk-compose-icon-mob"
              alt="no-img"
            />
          </button> -->
          <label class="extra-help-description quicksand-normal-label">
            Select a question below and click "Submit" to send the request to a classmate for extra help!
          </label>

          <ng-container [ngTemplateOutlet]="selectNoteQuestionContent"></ng-container>
        </div>
      </div>
    </ng-template>

    <ng-template #generateSolutionContent>
      <div [ngClass]="analyticsService?.currentTheme">
        <div class="{{ isExpand ? 'container' : 'container-fluid ' }} " [ngClass]="isHistoryOpen ? 'content' : ''">
          <h6 class="quicksand-bold-label mt-3 {{ isExpand ? '' : 'explain-this-heading' }}">Explain This</h6>

          <div
            class="row mb-0 mr-0 my-3 col-md-12 py-3 ml-1 {{ isExpand ? 'generate-solution-content-exp' : 'generate-solution-content' }} "
            [ngClass]="!isHistoryOpen ? 'explain-this' : ''"
            
          >
            <label class="quicksand-bold-label mr-2">Select Question <span class="required-field">*</span></label>
            <nb-select
              placeholder="Select Question"
              [(ngModel)]="generateQuestionInputValue"
              class="w-100 quicksand-bold-label select-generate-questions"
              (selectedChange)="onQuestionSelect($event)"
              (click)="checkForQuestions('assignment')"
              *ngIf="showAIAskedQuestion"
              [disabled]="buttonDisabled"
            >
              <nb-option [value]="question" *ngFor="let question of studentPreviouslyAskedQuestions" [disbled]="buttonDisabled">{{ question?.question | titlecase }}</nb-option>
            </nb-select>

            <nb-select
              placeholder="Select Question"
              [(ngModel)]="generateQuestionInputValue"
              class="w-100 quicksand-bold-label select-generate-questions"
              (selectedChange)="onQuestionSelect($event)"
              (click)="checkForQuestions('assignment')"
              *ngIf="!showAIAskedQuestion"
            [disabled]="buttonDisabled"
            >
              <nb-option [value]="question" *ngFor="let question of studentQuestions">{{ question?.content | titlecase }}</nb-option>
            </nb-select>
          </div>
          <div class="padding-top-explin-text d-flex justify-content-center {{ isExpand ? 'col-md-5' : 'col-md-6' }}">
            <button
              nbButton
              class="btn-generate-solution text-capitalize quicksand-bold-label w-100 {{ isExpand ? 'btn-gen-mr' : 'btn-gen-mr-exp' }}"
              (click)="generateSolution(true)"
              [disabled]="!generateQuestionInputValue || studentQuestions?.length === 0 || showAIAskedQuestion || buttonDisabled"
            >
              Explain
            </button>
            <!-- <button
                color="primary"
                class="restore-button-ai ml-2 float-right {{
                  isExpand ? 'btn-gen-mr' : 'btn-gen-mr-exp'
                }}"
                (click)="checkHistory()"
                title="See Previous Questions"
                *ngIf="extraHelpMode !== ''"
              >
                <img
                  src="/assets/icons/restore-clock.svg"
                  height="20"
                  width="20"
                  class="bulk-compose-icon-mob"
                  alt="no-img"
                />
              </button> -->
          </div>
        </div>
        <div *ngIf="!isEditing; else editMode">
          <div
            class="math-output mt-3 quicksand-bold-label"
            contenteditable="true"
            *ngIf="explainSolution"
            [mathjax]="utilService.getFormattedAnswers(explainSolution)"
            (input)="isEditing = true"
          ></div>
        </div>
        <ng-template #editMode>
          <textarea
            nbInput
            class="w-100 text-area quicksand-bold-label mt-3"
            mat-autosize="true"
            matInput
            cdkTextareaAutosize
            ngxTextareaAutoresize
            #autosize="cdkTextareaAutosize"
            *ngIf="explainSolution"
            [(ngModel)]="explainSolution"
          ></textarea>
        </ng-template>
      </div>
    </ng-template>

    <ng-template #selectNoteQuestionContent>
      <div [ngClass]="analyticsService?.currentTheme">
        <div class="form-group">
          <label class="quicksand-bold-label mr-2">Select Question <span class="required-field">*</span></label>
          <nb-select
            placeholder="Select Question"
            [(ngModel)]="generateQuestionInputValue"
            class="w-100 quicksand-bold-label select-generate-questions"
            (click)="checkForQuestions('assignment')"
            (ngModelChange)="onQuestionChange($event)"
            *ngIf="showAskedQuestion"
          >
            <nb-option [value]="question" *ngFor="let question of studentPreviouslyAskedQuestions">{{ question?.question | titlecase }}</nb-option>
          </nb-select>
          <nb-select
            placeholder="Select Question"
            [(selected)]="selectedQuestion"
            class="w-100 quicksand-bold-label"
            (selectedChange)="onQuestionChange($event)"
            (click)="checkForQuestions('student-teacher')"
            *ngIf="!showAskedQuestion"
          >
            <nb-option [value]="question" *ngFor="let question of studentQuestions">{{ question?.content | titlecase }}</nb-option>
          </nb-select>
        </div>

        <div class="form-group">
          <label class="quicksand-bold-label">Message <span class="required-field">*</span></label>
          <br />
          <textarea
            class="form-control message-input users-input text-area"
            nbInput
            id="comment"
            mat-autosize="true"
            [(ngModel)]="bulkMessage"
            [disabled]="studentQuestions?.length === 0"
          >
          </textarea>
        </div>

        <div class="form-group">
          <button
            nbButton
            class="btn-submit quicksand-bold-label text-capitalize w-100  {{ isExpand ? 'mb-3' : '' }}"
            (click)="addExtraHelp()"
            [disabled]="
              extraHelpMode === studentExtraHelpMode.Ask_Student || extraHelpMode === studentExtraHelpMode.Ask_Teacher
                ? !(selectedQuestion && studentQuestions.length > 0 && !showAskedQuestion)|| bulkMessage?.trim() === '': !bulkMessage
            "
          >
            Submit
          </button>
        </div>
      </div>
    </ng-template>
    <!-- no students found modal -->
    <ng-template #dialogHelp>
      <div [ngClass]="analyticsService?.currentTheme">
        <div>
          <span class="icon-close-classroom-modal d-block cursor-pointer ml-auto" (click)="dialog.closeAll()">
            <nb-icon icon="close-outline" class="icon-close"></nb-icon>
          </span>
        </div>

        <div class="text-center">
          <img src="/assets/icons/featured icon.svg" alt="share-icon" loading="lazy" />
          <br />
          <br />
          <label class="delete-lesson-plan-confirmation quicksand-bold-label"
            >No other classmates have answered this question correctly yet. Try "Explain the Solution" instead!
          </label>
        </div>
        <div class="d-flex justify-content-center">
          <button nbButton class="btn cursor-pointer ml-1 quicksand-bold-label text-capitalize mt-1 custom-button-ok" mat-dialog-close>Ok</button>
        </div>
      </div>
    </ng-template>
  </div>
  <ng-template #dialogDelete>
    <div [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
      <div class="text-center">
        <img src="/assets/icons/featured icon.svg" alt="delete-icon" loading="lazy" />
        <br />

        <label class="label-delete-lesson-plan mt-2 quicksand-bold-label">Delete Question</label>
        <br />
        <label class="label-delete-lesson-plan quicksand-bold-label">Are you sure want to delete this question ?</label>
      </div>
      <div class="d-flex">
        <button nbButton class="delete-lesson-plan bg-white bg-white-color m-2 w-100 quicksand-bold-label text-capitalize" (click)="dialogRef.close()">
          Cancel
        </button>
        <button nbButton color="warn" class="delete-lesson-plan delete m-2 w-100 quicksand-bold-label text-capitalize" (click)="deleteQuestion()">
          Delete
        </button>
      </div>
    </div>
  </ng-template>
</div>
